import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Charts from "../Echarts";
import SimpleSlider from "./Slider";
import ElectronGas from "../../../utils/m4k/semic_data/ElectronGas";
import marketSize from "../../../utils/m4k/semic_data/marketSize";
import CMP from "../../../utils/m4k/semic_data/CMP";
import sales from "../../../utils/m4k/semic_data/sales";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      textAlign: "center",
    },
    title: {
      height: "10vh",
      display: "flex",
      justifyContent: "center",
      color: "white",
      fontSize: "2vw",
    },
    global: {
      height: "20vh",
    },
    cmp: {},
    si: {},
    subTitle: {
      fontSize: "3vw",
      color: "#67e2f2",
    },
    thrTitle: {
      fontSize: "2vw",
      color: "#67e2f2",
    },
  })
);
const SemicLeft: React.FC = () => {
  const classes = useStyles();

  const styles = [{}, {}, { height: "30vh" }, { height: "calc(40vh - 10px)" }];

  return (
    <Grid container direction="row" className={classes.gridRoot}>
      <Grid item xs={12} className={classes.global}>
        <div style={{ marginTop: "4vh" }}>
          <SimpleSlider />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Charts option={marketSize} style={styles[3]} />
      </Grid>

      <Grid item xs={12}>
        <Charts option={sales} style={{ height: "calc(90vh / 3)" }} />
      </Grid>
    </Grid>
  );
};

export default SemicLeft;
